/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import Update from 'immutability-helper';
import {
  Dimmer,
  Segment,
  Loader,
  Label,
  Icon,
  Modal,
  Pagination,
  Input,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import OverviewIssueItem from './OverviewIssueItem';
import AssigningIssueModal from '../Modal/AssigningIssueModal';
import ChangeStatusIssueModal from '../Modal/ChangeStatusIssueModal';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import api from '../../api';
import Footer from '../Footer/Footer';
import WithRouter from '../Extensions/WithRouter';

class OverviewIssueList extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.state = {
      isOpenMAI: false,
      isOpenWarn: false,
      isOpenMCS: false,
      isLoading: false,
      isPageLoading: false,
      isDetailLoading: false,
      isDetailPageLoading: false,
      isLoadingMCS: false,
      isLoadingMAI: false,
      checkAllArray: [],
      checkAllSecurityArray: [],
      checkAllLicenseArray: [],
      checkAllLitigator: [],
      isVisible: '',
      isScrolling: '',
      error: false,
      errorDetail: false,
      hasMore: false,
      searchKeyword: '',
      pageSize: this.props.state.user.page_limit,
      detailPageSize: 30,
      sortValue: '8',
      isSort: false,
      activeIndex: [],
      issueList: [],
      statusList: [],
      assignList: [],
      filter: [],
      checkedValue: [],
      unCheckedValue: [],
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      isResizeHeaeder: false,
      activePage: '',
      isPageUpdate: false,
      totalCount: 0,
    };
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDetailScroll = this.handleDetailScroll.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleAssignIssue = this.handleAssignIssue.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.updateCheckValue = this.updateCheckValue.bind(this);
    this.updateCheckArray = this.updateCheckArray.bind(this);
    this.updateUnCheckArray = this.updateUnCheckArray.bind(this);
    this.updateStatusIssue = this.updateStatusIssue.bind(this);
    this.updatePopupCallback = this.updatePopupCallback.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleInputActivePageChange = this.handleInputActivePageChange.bind(this);
    this.handleActivePageChange = this.handleActivePageChange.bind(this);
    this.handleIssueCallback = this.handleIssueCallback.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.setAssignIssue = this.setAssignIssue.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.onUpdatePredicate = this.onUpdatePredicate.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.clearValue = this.clearValue.bind(this);
    this.clearAllValue = this.clearAllValue.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
    this.onUpdatePredicate();
    window.addEventListener('resize', this.onUpdatePredicate);
    if (this.overviewIssues) {
      this.onUpdateLoading();
    }
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    $(document).on('mouseover', '.wide_card_table td', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isPageUpdate, isSelectable, pageSize, viewMode
    } = this.state;
    const { state, navigateType } = this.props;
    const { page_limit, view_mode } = toJS(state.user);

    if (pageSize === '' && page_limit !== '') {
      this.setState({
        pageSize: page_limit,
      });
    }

    if (viewMode === '' && view_mode !== '') {
      this.setState({
        viewMode: view_mode,
      });
    }

    if (prevState.isPageUpdate !== isPageUpdate && isPageUpdate) {
      if (navigateType === 'POP') {
        let storageSession = {};
        if (localStorage.getItem('session')) {
          storageSession = JSON.parse(localStorage.getItem('session'));
          api.getUserProfile(storageSession.access_token)
            .then((res) => {
              const data = res.response;
              this.getOverviewIssueList(1, data.page_limit);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        this.getOverviewIssueList();
      }
      this.setState({
        isPageUpdate: false,
      });
    }

    if (isSelectable !== prevState.isSelectable) {
      this.onUpdatePredicate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    window.removeEventListener('resize', this.onUpdatePredicate);
  }

  handleIssueCallback() {
    this.setState(
      {
        issueList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  }

  handleSearchChange(value) {
    this.setState({
      searchKeyword: value,
    });
  }

  handleActivePageChange(e) {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        issueList: [],
        activeIndex: [],
        checkAllArray: [],
        statusList: [],
        checkedValue: [],
        unCheckedValue: [],
        currentPage: activePage,
      }, () => {
        this.getOverviewIssueList(activePage, pageSize);
      });
    }
  }

  handleInputActivePageChange(e, { value }) {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  }

  handleAssignIssue() {
    const { checkedValue, checkAllArray, issueList } = this.state;
    const { t } = this.props;
    let rowData;
    this.modalBody = t('my_page.my_issue.message.select_one_issue');

    if (checkedValue.length === 0) {
      return this.setState({
        isOpenWarn: true,
      });
    }

    if (checkAllArray.length === 0) {
      rowData = checkedValue.map((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          const scannedFileId = Number(string[1]);
          const selectedIssue = issueList.filter((list) => {
            return list.uploaded_file_id === uploadedFileId;
          });

          const scannedFIles = selectedIssue[0].issue_list.filter((entity) => {
            return entity.scanned_file_id === scannedFileId;
          });

          const newArray = scannedFIles.map((entity) => {
            return {
              uploaded_file_id: uploadedFileId,
              scanned_file_id: scannedFileId,
              name: entity.scanned_file,
              type: 'scanned_file',
              status: entity.status,
            };
          });
          return newArray;
        }
        const selectedIssue = issueList.filter((list) => {
          return list.uploaded_file_id === item;
        });

        return {
          uploaded_file_id: selectedIssue[0].uploaded_file_id,
          name: selectedIssue[0].name,
          type: 'uploaded_file',
          status: selectedIssue[0].status,
        };
      });
    } else {
      const uniqueCheckedValue_1 = checkedValue.filter((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          return checkAllArray.indexOf(uploadedFileId) === -1;
        }
        return checkAllArray.indexOf(item) === -1;
      });

      const uniqueValueArray = uniqueCheckedValue_1.map((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          const scannedFileId = Number(string[1]);
          const selectedIssue = issueList.filter((list) => {
            return list.uploaded_file_id === uploadedFileId;
          });

          const scannedFIles = selectedIssue[0].issue_list.filter((entity) => {
            return entity.scanned_file_id === scannedFileId;
          });

          const newArray = scannedFIles.map((entity) => {
            return {
              uploaded_file_id: uploadedFileId,
              scanned_file_id: scannedFileId,
              name: entity.scanned_file,
              type: 'scanned_file',
              status: entity.status,
            };
          });
          return newArray;
        }
        const selectedIssue = issueList.filter((list) => {
          return list.uploaded_file_id === item;
        });

        return {
          uploaded_file_id: selectedIssue[0].uploaded_file_id,
          name: selectedIssue[0].name,
          type: 'uploaded_file',
          status: selectedIssue[0].status,
        };
      });

      const selectAlluploadedArray = issueList.filter((item) => {
        return checkAllArray.indexOf(item.uploaded_file_id) > -1;
      });

      rowData = selectAlluploadedArray.map((item) => {
        return {
          uploaded_file_id: item.uploaded_file_id,
          name: item.name,
          type: 'uploaded_file',
          status: item.status,
        };
      });

      rowData = rowData.concat(uniqueValueArray);
    }

    //assignList
    return this.setState({
      isOpenMAI: true,
      assignList: rowData,
    });
  }

  handleChangeStatus() {
    const { checkedValue, checkAllArray, issueList } = this.state;
    const { t } = this.props;
    let rowData;
    this.modalBody = t('my_page.my_issue.message.select_one_issue');

    if (checkedValue.length === 0) {
      return this.setState({
        isOpenWarn: true,
      });
    }

    if (checkAllArray.length === 0) {
      rowData = checkedValue.map((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          const scannedFileId = Number(string[1]);
          const selectedIssue = issueList.filter((list) => {
            return list.uploaded_file_id === uploadedFileId;
          });

          const scannedFIles = selectedIssue[0].issue_list.filter((entity) => {
            return entity.scanned_file_id === scannedFileId;
          });

          const newArray = scannedFIles.map((entity) => {
            return {
              uploaded_file_id: uploadedFileId,
              scanned_file_id: scannedFileId,
              name: entity.scanned_file,
              type: 'scanned_file',
              status: entity.status,
            };
          });
          return newArray;
        }
        const selectedIssue = issueList.filter((list) => {
          return list.uploaded_file_id === item;
        });

        return {
          uploaded_file_id: selectedIssue[0].uploaded_file_id,
          name: selectedIssue[0].name,
          type: 'uploaded_file',
          status: selectedIssue[0].status,
        };
      });
    } else {
      const uniqueCheckedValue_1 = checkedValue.filter((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          return checkAllArray.indexOf(uploadedFileId) === -1;
        }
        return checkAllArray.indexOf(item) === -1;
      });

      const uniqueValueArray = uniqueCheckedValue_1.map((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          const uploadedFileId = Number(string[0]);
          const scannedFileId = Number(string[1]);
          const selectedIssue = issueList.filter((list) => {
            return list.uploaded_file_id === uploadedFileId;
          });

          const scannedFIles = selectedIssue[0].issue_list.filter((entity) => {
            return entity.scanned_file_id === scannedFileId;
          });

          const newArray = scannedFIles.map((entity) => {
            return {
              uploaded_file_id: uploadedFileId,
              scanned_file_id: scannedFileId,
              name: entity.scanned_file,
              type: 'scanned_file',
              status: entity.status,
            };
          });
          return newArray;
        }
        const selectedIssue = issueList.filter((list) => {
          return list.uploaded_file_id === item;
        });

        return {
          uploaded_file_id: selectedIssue[0].uploaded_file_id,
          name: selectedIssue[0].name,
          type: 'uploaded_file',
          status: selectedIssue[0].status,
        };
      });

      const selectAlluploadedArray = issueList.filter((item) => {
        return checkAllArray.indexOf(item.uploaded_file_id) > -1;
      });

      rowData = selectAlluploadedArray.map((item) => {
        return {
          uploaded_file_id: item.uploaded_file_id,
          name: item.name,
          type: 'uploaded_file',
          status: item.status,
        };
      });

      rowData = rowData.concat(uniqueValueArray);
    }

    return this.setState({
      isOpenMCS: true,
      statusList: rowData,
    });
  }

  handleFilterData(value) {
    this.setState(
      {
        activeIndex: [],
        issueList: [],
        filter: value.filter,
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  }

  handleChange(value) {
    this.setState(
      {
        searchKeyword: value,
        issueList: [],
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  }

  handlePageSizeChange(value) {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        issueList: [],
        activeIndex: [],
        checkAllArray: [],
        statusList: [],
        checkedValue: [],
        unCheckedValue: [],
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  }

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      issueList: [],
      activeIndex: [],
      checkAllArray: [],
      statusList: [],
      checkedValue: [],
      unCheckedValue: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getOverviewIssueList(activePage, pageSize);
    });
  };

  handleOnScroll() {
    const {
      getOverviewIssueList,
      state: {
        error, isPageLoading, hasMore, viewMode, currentPage
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isPageLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getOverviewIssueList(currentPage + 1);
    }
  }

  handleDetailScroll(ufid, nextPage, perPage) {
    this.getOverviewIssueDetail(ufid, nextPage, perPage);
  }

  onUpdateLoading() {
    this.setState({
      isPageUpdate: true,
    });
  }

  onUpdatePredicate() {
    const { isSelectable } = this.state;
    if (isSelectable) {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1500,
      });
    } else {
      this.setState({
        isResizeHeaeder: window.innerWidth < 1300,
      });
    }
  }

  setAssignIssue = (ids) => {
    this.setState(
      {
        searchKeyword: '',
        //activeIndex: [],
        //issueList: [],
        checkAllArray: [],
        assignList: [],
        checkedValue: [],
        unCheckedValue: [],
        isLoadingMAI: true,
      },
      () => {
        ids.forEach(async (item, index) => {
          await this.delayedUpdateCallback(item, index, ids.length);
        });
        //this.getOverviewIssueList();
      }
    );
  };

  getOverviewIssueList = (pageNo, limit) => {
    let text;
    let filterData;
    const {
      searchKeyword, pageSize, isSort, sortValue, filter, issueList
    } = this.state;
    const { state } = this.props;

    const page = pageNo || 1;
    let perPage = limit || pageSize;

    if (perPage === '') {
      perPage = state.user.page_limit || localStorage.getItem('page_limit');
    }

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
    }

    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'report';
      } else {
        text = 'report_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'file_r';
      } else {
        text = 'file';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_r';
      } else {
        text = 'component';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'component_version_r';
      } else {
        text = 'component_version';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'security_r';
      } else {
        text = 'security';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'license_r';
      } else {
        text = 'license';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'litigator_r';
      } else {
        text = 'litigator';
      }
      break;
    case sortValue === '8':
      if (isSort) {
        text = 'uploaded_r';
      } else {
        text = 'uploaded';
      }
      break;
    default:
      text = 'uploaded';
      break;
    }

    const data = {
      search: searchKeyword,
      filter: filterData,
      page,
      limit: perPage,
      order: text,
    };

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isPageLoading: true,
      });
    }

    api
      .getOverviewIssueList(data)
      .then((response) => {
        const res = response.response;
        if (page === 1 && response.response.length === 0) {
          return this.setState({
            isLoading: false,
            isPageLoading: false,
          });
        }
        this.setState({
          currentPage: response.pagination.current,
          pageSize: response.pagination.per_page,
          totalPage: response.pagination.pages,
          totalCount: response.pagination.count,
          hasMore: response.pagination.next !== null,
          issueList: [...issueList, ...res],
          isLoading: false,
          isPageLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isPageLoading: false,
        });
      });
  };

  getOverviewIssueDetail = (ufid, pageNo, limit) => {
    const {
      detailPageSize, issueList, checkedValue, checkAllArray, unCheckedValue
    } = this.state;
    const page = pageNo || 1;
    const perPage = limit || detailPageSize;

    const obj = {
      page,
      limit: perPage,
    };

    if (page === 1) {
      this.setState({
        isDetailLoading: true,
        isVisible: ufid,
      });
    } else {
      this.setState({
        isDetailPageLoading: true,
        isScrolling: ufid,
      });
    }

    api
      .getOverviewIssueDetail(obj, ufid)
      .then((response) => {
        let updatedData;
        const data = response.response;
        const updatedIndex = issueList.findIndex((item) => {
          return item.uploaded_file_id === ufid;
        });

        if (page === 1) {
          updatedData = Update(issueList[updatedIndex], {
            issue_list: { $set: data.issue_list },
            project_name: { $set: data.project_name },
            project_version_name: { $set: data.project_version_name },
            uploaded_file_owner: { $set: data.uploaded_file_owner },
            issue_owner: { $set: data.issue_owner },
            issue_status: { $set: data.issue_status },
            detail_info: { $set: data.pagination },
          });
        } else {
          updatedData = Update(issueList[updatedIndex], {
            issue_list: { $push: data.issue_list },
            detail_info: { $set: data.pagination },
          });
        }

        const newData = Update(issueList, {
          $splice: [[updatedIndex, 1, updatedData]],
        });

        if (checkAllArray.indexOf(ufid) > -1) {
          const applyNextPageValue = data.issue_list.map((item) => {
            return `${ufid}_${item.scanned_file_id}`;
          });
          const newCheckValue = checkedValue.concat(applyNextPageValue);

          if (checkedValue.indexOf(ufid) === -1) {
            const applyUnCheckedValue = newCheckValue.filter((item) => {
              return unCheckedValue.indexOf(item) === -1;
            });
            const unique = this.uniqueFilter(applyUnCheckedValue);
            this.setState({
              checkedValue: unique,
            });
          } else {
            const unique = this.uniqueFilter(newCheckValue);

            this.setState({
              checkedValue: unique,
            });
          }
        }

        this.setState({
          issueList: newData,
          isDetailLoading: false,
          isDetailPageLoading: false,
          isVisible: '',
          isScrolling: '',
        });
      })
      .catch((err) => {
        this.setState({
          errorDetail: err,
          isDetailLoading: false,
          isDetailPageLoading: false,
          isVisible: '',
          isScrolling: '',
        });
      });
  };

  onChangeSorting = (e) => {
    const { sortValue, isSort } = this.state;
    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          issueList: [],
          activeIndex: [],
        },
        () => {
          this.getOverviewIssueList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          issueList: [],
          activeIndex: [],
        },
        () => {
          this.getOverviewIssueList();
        }
      );
    }
  };

  toggleViewMode = (value) => {
    this.setState(
      {
        currentPage: 1,
        issueList: [],
        activeIndex: [],
        checkAllArray: [],
        statusList: [],
        checkedValue: [],
        unCheckedValue: [],
        searchKeyword: '',
        viewMode: value,
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  };

  toggleRow = (e, uid) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(uid) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== uid;
      });
    } else {
      this.getOverviewIssueDetail(uid);
      newState = [...activeIndex, uid];
    }

    this.setState({
      activeIndex: newState,
    });
  };

  delayedUpdateCallback = (item, index, idsLength) => {
    let timeOut;
    if (idsLength === 1) {
      timeOut = 3000;
    } else if (idsLength > 1) {
      if (index === 0) {
        timeOut = 3000;
      } else {
        timeOut = 6500;
      }
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        this.updatePopupCallback(item, index, idsLength);
        resolve();
      }, timeOut);
    });
  };

  updatePopupCallback = (ufid, index, idsLength) => {
    const { issueList } = this.state;
    let updatedData;

    const obj = {
      page: 1,
      limit: 30,
    };

    this.setState({
      isDetailLoading: true,
      isVisible: ufid,
    }, () => {
      api
        .getOverviewIssueDetail(obj, ufid)
        .then((response) => {
          if (!index) {
            const data = response.response;
            const updatedIndex = issueList.findIndex((item) => {
              return item.uploaded_file_id === ufid;
            });

            updatedData = Update(issueList[updatedIndex], {
              issue_owner: { $set: data.issue_owner },
              issue_status: { $set: data.issue_status },
              issue_list: { $set: data.issue_list },
              detail_info: { $set: data.pagination },
            });

            const newData = Update(issueList, {
              $splice: [[updatedIndex, 1, updatedData]],
            });

            return this.setState({
              issueList: newData,
              isVisible: '',
              isDetailLoading: false,
              isLoadingMCS: false,
              isOpenMCS: false,
              isLoadingMAI: false,
              isOpenMAI: false,
            });
          }

          if (index === 0) {
            const data = response.response;
            const updatedIndex = issueList.findIndex((item) => {
              return item.uploaded_file_id === ufid;
            });

            updatedData = Update(issueList[updatedIndex], {
              issue_owner: { $set: data.issue_owner },
              issue_status: { $set: data.issue_status },
              issue_list: { $set: data.issue_list },
              detail_info: { $set: data.pagination },
            });

            const newData = Update(issueList, {
              $splice: [[updatedIndex, 1, updatedData]],
            });

            if (idsLength === 1) {
              this.setState({
                issueList: newData,
                isVisible: '',
                isDetailLoading: false,
                isLoadingMCS: false,
                isOpenMCS: false,
                isLoadingMAI: false,
                isOpenMAI: false,
              });
            } else {
              this.setState({
                issueList: newData,
                isVisible: '',
                isDetailLoading: false,
              });
            }
          } else {
            const data = response.response;
            const updatedIndex = issueList.findIndex((item) => {
              return item.uploaded_file_id === ufid;
            });

            updatedData = Update(issueList[updatedIndex], {
              issue_owner: { $set: data.issue_owner },
              issue_status: { $set: data.issue_status },
              issue_list: { $set: data.issue_list },
              detail_info: { $set: data.pagination },
            });

            const newData = Update(issueList, {
              $splice: [[updatedIndex, 1, updatedData]],
            });

            if (idsLength === index + 1) {
              this.setState({
                issueList: newData,
                isVisible: '',
                isDetailLoading: false,
                isLoadingMCS: false,
                isOpenMCS: false,
                isLoadingMAI: false,
                isOpenMAI: false,
              });
            } else {
              this.setState({
                issueList: newData,
                isVisible: '',
                isDetailLoading: false,
              });
            }
          }

        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isDetailLoading: false,
            isVisible: '',
            isLoadingMCS: false,
            isOpenMCS: false,
            isLoadingMAI: false,
            isOpenMAI: false,
          });
        });
    });
  };

  clearAllValue = () => {
    this.setState(
      {
        issueList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;

    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        issueList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  };

  closeModal() {
    this.setState({
      isOpenMAI: false,
      isOpenWarn: false,
      isOpenMCS: false,
    });
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        issueList: [],
        activeIndex: [],
      },
      () => {
        this.getOverviewIssueList();
      }
    );
  }

  updateCheckValue(value) {
    this.setState({
      checkedValue: value,
    });
  }

  updateUnCheckArray(value) {
    this.setState({
      unCheckedValue: value,
    });
  }

  updateCheckArray(value, string) {
    this.setState({
      [string]: value,
    });
  }

  updateStatusIssue(ids) {
    this.setState(
      {
        searchKeyword: '',
        //activeIndex: [],
        //issueList: [],
        checkAllArray: [],
        statusList: [],
        checkedValue: [],
        unCheckedValue: [],
        isLoadingMCS: true,
      },
      () => {
        ids.forEach(async (item, index) => {
          await this.delayedUpdateCallback(item, index, ids.length);
        });
        //this.getOverviewIssueList();
      }
    );
  }

  uniqueFilter(array) {
    const unique = array.reduce((a, b) => {
      if (a.indexOf(b) < 0) {
        a.push(b);
      }
      return a;
    }, []);
    return unique;
  }

  renderValue() {
    const { filter } = this.state;
    const { t } = this.props;

    const securityFilter = filter.filter((item) => {
      return item.indexOf('security') > -1;
    });

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const litigatorFilter = filter.filter((item) => {
      return item.indexOf('litigator') > -1;
    });

    const securityIssue = filter.filter((item) => {
      return item.indexOf('status_sc') > -1;
    });

    const licenseIssue = filter.filter((item) => {
      return item.indexOf('status_lc') > -1;
    });

    const litigatorIssue = filter.filter((item) => {
      return item.indexOf('status_lt') > -1;
    });

    const filterObj = {
      security: securityFilter,
      license: licenseFilter,
      litigator: litigatorFilter,
      securityIssue,
      licenseIssue,
      litigatorIssue,
    };

    return (
      <div>
        {filterObj.security.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.security')}</strong>
            </span>
            {filterObj.security.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_c') > -1 && 'Critical'}
                  {item.indexOf('_h') > -1 && 'High'}
                  {item.indexOf('_m') > -1 && 'Medium'}
                  {item.indexOf('_l') > -1 && 'Low'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.securityIssue.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.security_issue')}</strong>
            </span>
            {filterObj.securityIssue.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_sc_u') > -1 && 'Undecided'}
                  {item.indexOf('_sc_r') > -1 && 'Resolved'}
                  {item.indexOf('_sc_d') > -1 && 'Disregarded'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('project.menu.license')}</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && 'Protective'}
                  {item.indexOf('_pm') > -1 && 'Permissive'}
                  {item.indexOf('_o') > -1 && 'Others'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.licenseIssue.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.license_issue')}</strong>
            </span>
            {filterObj.licenseIssue.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_lc_u') > -1 && 'Undecided'}
                  {item.indexOf('_lc_r') > -1 && 'Resolved'}
                  {item.indexOf('_lc_d') > -1 && 'Disregarded'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.litigator.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.litigator')}</strong>
            </span>
            {filterObj.litigator.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_a') > -1 && t('card.menu.applicable')}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filterObj.litigatorIssue.length !== 0 && (
          <Label.Group>
            <span>
              <strong>{t('contents_header.menu.litigator_issue')}</strong>
            </span>
            {filterObj.litigatorIssue.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_lt_u') > -1 && 'Undecided'}
                  {item.indexOf('_lt_r') > -1 && 'Resolved'}
                  {item.indexOf('_lt_d') > -1 && 'Disregarded'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}
        {filter.length > 1 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );

  }

  render() {
    const {
      state,
      location,
      params,
      t,
      navigate,
    } = this.props;
    const {
      activeIndex,
      isSort,
      sortValue,
      isLoading,
      isPageLoading,
      issueList,
      hasMore,
      error,
      isDetailLoading,
      isDetailPageLoading,
      errorDetail,
      isVisible,
      isScrolling,
      filter,
      checkedValue,
      unCheckedValue,
      checkAllArray,
      checkAllSecurityArray,
      checkAllLicenseArray,
      checkAllLitigator,
      pageSize,
      viewMode,
      currentPage,
      totalPage,
      isResizeHeaeder,
      activePage,
      isOpenMAI,
      isLoadingMAI,
      isOpenMCS,
      isLoadingMCS,
      statusList,
      isOpenWarn,
      assignList,
      searchKeyword,
      totalCount
    } = this.state;

    return (
      <div
        ref={(ref) => {
          this.overviewIssues = ref;
        }}
      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          handleAssignIssue={this.handleAssignIssue}
          handleChangeStatus={this.handleChangeStatus}
          filter={filter}
          pageSize={pageSize}
          viewMode={viewMode}
          isResizeHeaeder={isResizeHeaeder}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
          totalCount={totalCount}
        />
        <div className="content">
          {filter.length !== 0 ? (
            <div className="tag_list">{this.renderValue()}</div>
          ) : null}
          <div className="content_projects_list">
            <div className="wide_card_wrap my_issues_item_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '16.2%', maxWidth: '180px' }} />
                      <col style={{ width: '5.5%', maxWidth: '62px' }} />
                      <col style={{ width: '5.5%', maxWidth: '62px' }} />
                      <col style={{ width: '5.5%', maxWidth: '62px' }} />
                      <col style={{ width: '16%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '8.5%' }} />
                      <col style={{ width: '' }} />
                      <col style={{ width: '' }} />
                      <col style={{ width: '4%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap">
                          {/**<Checkbox />*/}
                        </th>
                        <th>
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.uploaded_files')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.scanned_file')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          {/**<Checkbox /> */}
                          <a className="sorting_button" data-id="5" onClick={this.onChangeSorting} style={{ marginLeft: '15px' }} onKeyUp={this.onChangeSorting}>
                            {t('list.title.security_risk')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          {/*<Checkbox />*/}
                          <a className="sorting_button" data-id="6" onClick={this.onChangeSorting} style={{ marginLeft: '15px' }} onKeyUp={this.onChangeSorting}>
                            {t('list.title.license')}
                            {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          {/*<Checkbox />*/}
                          <a className="sorting_button" data-id="7" onClick={this.onChangeSorting} style={{ marginLeft: '10px' }} onKeyUp={this.onChangeSorting}>
                            {t('list.title.litigator')}
                            {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a className="sorting_button" data-id="8" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                            {t('modal.button.upload')}
                            {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {
                !isLoading ? (
                  <div>
                    {
                      issueList.length !== 0
                        ? issueList.map((item) => {
                          return (
                            <OverviewIssueItem
                              key={item.uploaded_file_id}
                              rowData={item}
                              activeIndex={activeIndex}
                              isDetailLoading={isDetailLoading}
                              isDetailPageLoading={isDetailPageLoading}
                              errorDetail={errorDetail}
                              isVisible={isVisible}
                              isScrolling={isScrolling}
                              checkedValue={checkedValue}
                              unCheckedValue={unCheckedValue}
                              checkAllArray={checkAllArray}
                              checkAllSecurityArray={checkAllSecurityArray}
                              checkAllLicenseArray={checkAllLicenseArray}
                              checkAllLitigator={checkAllLitigator}
                              toggleRow={this.toggleRow}
                              handleDetailScroll={this.handleDetailScroll}
                              updateCheckValue={this.updateCheckValue}
                              updateCheckArray={this.updateCheckArray}
                              updateUnCheckArray={this.updateUnCheckArray}
                              updatePopupCallback={this.updatePopupCallback}
                              handleIssueCallback={this.handleIssueCallback}
                              location={location}
                              translate={t}
                            />
                          );
                        })
                        : null
                    }
                    {error && <div style={{ color: '#900' }}>{t('modal.error.page_loading_error')}</div>}
                    {isPageLoading && (
                      <Segment>
                        <Dimmer active inverted>
                          <Loader size="medium">{t('list.title.loading')}</Loader>
                        </Dimmer>
                      </Segment>
                    )}
                  </div>
                ) : (
                  <div style={{ paddingTop: '25px' }}>
                    <Loader active={isLoading} inline="centered" />
                  </div>
                )
              }
              {
                viewMode === 'list' && issueList.length !== 0
                && (
                  <div style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <AssigningIssueModal
          isOpenMAI={isOpenMAI}
          isLoading={isLoadingMAI}
          closeModal={this.closeModal}
          rowData={assignList}
          checkedValue={checkedValue}
          unCheckedValue={unCheckedValue}
          checkAllArray={checkAllArray}
          completeCallback={this.setAssignIssue}
          translate={t}
        />
        <ChangeStatusIssueModal
          isOpenMCS={isOpenMCS}
          isLoading={isLoadingMCS}
          closeModal={this.closeModal}
          rowData={statusList}
          checkedValue={checkedValue}
          unCheckedValue={unCheckedValue}
          checkAllArray={checkAllArray}
          completeCallback={this.updateStatusIssue}
          translate={t}
        />
        <Modal open={isOpenWarn} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default WithRouter(withTranslation()(inject('state')(observer(OverviewIssueList))));
